var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0303 9.46965C9.73741 9.17676 9.26253 9.17676 8.96964 9.46965C8.67675 9.76255 8.67675 10.2374 8.96964 10.5303L10.9393 12.5L8.96966 14.4697C8.67677 14.7625 8.67677 15.2374 8.96966 15.5303C9.26255 15.8232 9.73743 15.8232 10.0303 15.5303L12 13.5607L13.9696 15.5303C14.2625 15.8232 14.7374 15.8232 15.0303 15.5303C15.3232 15.2374 15.3232 14.7625 15.0303 14.4696L13.0606 12.5L15.0303 10.5303C15.3232 10.2374 15.3232 9.76257 15.0303 9.46968C14.7374 9.17678 14.2625 9.17678 13.9696 9.46968L12 11.4393L10.0303 9.46965Z",
    fill: "currentColor",
    fillOpacity: 0.86
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.75C6.06294 1.75 1.25 6.56294 1.25 12.5C1.25 18.4371 6.06294 23.25 12 23.25C17.9371 23.25 22.75 18.4371 22.75 12.5C22.75 6.56294 17.9371 1.75 12 1.75ZM2.75 12.5C2.75 7.39137 6.89137 3.25 12 3.25C17.1086 3.25 21.25 7.39137 21.25 12.5C21.25 17.6086 17.1086 21.75 12 21.75C6.89137 21.75 2.75 17.6086 2.75 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.86
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/Close Circle.21fca1b64e820a767c8acceecdaaf374.svg";
export { ForwardRef as ReactComponent };